const BlogCards = ({ items, title, description }) => {
  const normalizedItems = items.map((item) => {
    return {
      title: item.title,
      description: item.description,
      icon: item.icon,
    }
  })

  const normalizedData = {
    title,
    description,
    theme: 'white',
    items: normalizedItems,
  }

  return normalizedData
}

export default BlogCards
